import React, { createContext } from 'react';

export const NoteBookReportContext = createContext();